<template>
  <a-modal class="publicModel" :width="'48rem'" :closable="model.close" :visible="value"
    :centered="model.center">
    <div class="titleBox">
      <div class="item">{{ type === 'bind' ? '请绑定邮箱' : '修改邮箱' }}</div>
      <div class="close" @click="closeModal">
        <a-icon type="close" />
      </div>
    </div>
    <a-form-model class="formBox" :model="emailForm">
      <a-form-model-item>
        <a-input v-model="emailForm.email" placeholder="请输入新的邮箱地址" />
      </a-form-model-item>
      <a-form-model-item class="flex">
        <a-input v-model="emailForm.vc" placeholder="请输入验证码" />
        <div class="codeBox" :class="emailState == 1 ? 'edit':''" @click="clickEmailCode">
          <template v-if="emailState == 0">
            发送验证码
          </template>
          <template v-else-if="emailState == 1">
            {{emailTime}}
          </template>
          <template v-else-if="emailState == 2">
            重新发送
          </template>
        </div>
      </a-form-model-item>
      <a-button class="btn" @click="confirmEmail">{{ type === 'bind' ? '确认绑定' : '确认修改' }}</a-button>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  name: 'EmailModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'edit', // 'edit' 表示修改邮箱，'bind' 表示绑定邮箱
      validator: (value) => ['edit', 'bind'].includes(value)
    }
  },
  data() {
    return {
      model: {
        close: false,
        center: true,
      },
      emailForm: {},
      emailState: 0, // 0: 初始状态, 1: 倒计时中, 2: 可以重新发送
      emailTimer: 0,
      emailTime: 60
    }
  },
  methods: {
    closeModal() {
      this.$emit('input', false);
      this.clearForm();
    },
    clearForm() {
      this.emailForm = {};
      this.emailState = 0;
      if (this.emailTimer) {
        clearInterval(this.emailTimer);
        this.emailTimer = 0;
      }
    },
    clickEmailCode() {
      if (!this.emailForm.email || this.emailForm.email === "") {
        this.$message.error("请先输入邮箱地址");
        return;
      }

      // 验证邮箱格式
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.emailForm.email)) {
        this.$message.error("请输入正确的邮箱格式");
        return;
      }

      switch (this.emailState) {
        case 0:
        case 2:
          this.$reqToken("post", "/sso/sendEmail", {email: this.emailForm.email}).then((res) => {
            if(res.code && res.code == 200){
              this.$message.success("验证码发送成功");
              this.emailState = 1;
              this.emailTime = 60;
              this.emailTimer = setInterval(() => {
                this.emailTime--;
                if (this.emailTime <= 0) {
                  window.clearInterval(this.emailTimer)
                  this.emailState = 2;
                };
              }, 1000)
            }else{
              this.$message.error(res.msg || "发送失败");
            }
          }).catch((err) => {
            this.$message.error("发送失败，请稍后重试");
          });
          break;
      }
    },
    confirmEmail() {
      if (!this.emailForm.email || this.emailForm.email === "") {
        this.$message.error("请输入新的邮箱");
        return;
      }

      if (!this.emailForm.vc || this.emailForm.vc === "") {
        this.$message.error("请输入验证码");
        return;
      }

      // 验证邮箱格式
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.emailForm.email)) {
        this.$message.error("请输入正确的邮箱格式");
        return;
      }

      this.$reqToken("post", "/sso/updateEmail", this.emailForm).then((res) => {
        if(res.code && res.code == 200){
          this.$message.success(this.type === 'bind' ? "绑定邮箱成功" : "修改邮箱成功");
          this.$emit('input', false);
          this.$emit('success');
          this.clearForm();
        } else {
          this.$message.error(res.msg || (this.type === 'bind' ? "绑定邮箱失败" : "修改邮箱失败"));
        }
      }).catch((err) => {
        this.$message.error(this.type === 'bind' ? "绑定邮箱失败，请稍后重试" : "修改邮箱失败，请稍后重试");
      });
    }
  },
  beforeDestroy() {
    // 清理定时器
    if (this.emailTimer) {
      clearInterval(this.emailTimer);
    }
  }
}
</script>